"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionBuilder = void 0;
var __1 = require("..");
var Address_1 = __importDefault(require("../Components/Wallet/Address"));
var Contract_1 = require("../Consensus/Types/Locks/Contract");
var Outputs_1 = require("../Consensus/Transaction/Outputs");
var Inputs_1 = require("../Consensus/Transaction/Inputs");
var RawTransaction_1 = require("../Consensus/Transaction/RawTransaction");
var BigInteger = require("bigi");
var TransactionBuilder = /** @class */ (function () {
    function TransactionBuilder(chain) {
        this.chain = chain;
        this.inputs = [];
        this.outputs = [];
    }
    TransactionBuilder.prototype.addInput = function (txHash, index, privateKey) {
        if (typeof txHash === 'string') {
            txHash = new __1.Hash(txHash);
        }
        this.inputs.push({
            privateKey: privateKey,
            input: new __1.Input({
                kind: 'outpoint',
                txHash: txHash,
                index: index
            })
        });
    };
    TransactionBuilder.prototype.getInputs = function () {
        if (this.inputs)
            return this.inputs;
        throw new Error('inputs is not valid');
    };
    TransactionBuilder.prototype.getOutputs = function () {
        if (this.outputs)
            return this.outputs;
        throw new Error('outputs is not valid');
    };
    TransactionBuilder.prototype.addOutput = function (address, amount, asset) {
        var decodedAddress;
        if (typeof address === 'string') {
            decodedAddress = Address_1.default.decode(this.chain, address);
            address = new __1.PK(decodedAddress);
            if (decodedAddress instanceof __1.ContractId)
                address = new Contract_1.Contract(decodedAddress);
        }
        if (typeof asset === 'string')
            asset = new __1.Asset(asset);
        if (typeof amount === 'number')
            amount = new BigInteger(amount.toString(10), 10, undefined);
        var output = new __1.Output(address, new __1.Spend(asset, amount));
        this.outputs.push(output);
    };
    TransactionBuilder.prototype.addOutputDestroy = function (amount, asset) {
        if (typeof asset === 'string')
            asset = new __1.Asset(asset);
        if (typeof amount === 'number')
            amount = new BigInteger(amount.toString(10), 10, undefined);
        var output = new __1.Output(new __1.Destroy(), new __1.Spend(asset, amount));
        this.outputs.push(output);
    };
    TransactionBuilder.prototype.hash = function () {
        var inputs = this.inputs.map(function (input) { return input.input; });
        var tx = new __1.Transaction(0, new Inputs_1.Inputs(inputs), new Outputs_1.Outputs(this.outputs));
        return tx.hash();
    };
    TransactionBuilder.prototype.getUnsignedTransaction = function (version, contract) {
        if (version === void 0) { version = 0; }
        var inputs = this.inputs.map(function (input) { return input.input; });
        return new __1.Transaction(version, new Inputs_1.Inputs(inputs), new Outputs_1.Outputs(this.outputs), contract);
    };
    TransactionBuilder.prototype.getUnsignedRawTransaction = function (rawWitnessess, version, contract) {
        if (version === void 0) { version = 0; }
        var inputs = this.inputs.map(function (input) { return input.input; });
        return new RawTransaction_1.RawTransaction(version, new Inputs_1.Inputs(inputs), new Outputs_1.Outputs(this.outputs), contract, rawWitnessess);
    };
    TransactionBuilder.prototype.sign = function (version, contract) {
        if (version === void 0) { version = 0; }
        return this.getUnsignedTransaction(version, contract).sign(this.getKeys());
    };
    TransactionBuilder.prototype.getKeys = function () {
        return this.inputs.map(function (input) {
            if (!input.privateKey)
                throw new Error('missing private key');
            return input.privateKey;
        });
    };
    return TransactionBuilder;
}());
exports.TransactionBuilder = TransactionBuilder;
//# sourceMappingURL=TransactionBuilder.js.map